import { render } from "./NewChatForm.vue?vue&type=template&id=6d86e632&scoped=true"
import script from "./NewChatForm.vue?vue&type=script&lang=js"
export * from "./NewChatForm.vue?vue&type=script&lang=js"

import "./NewChatForm.vue?vue&type=style&index=0&id=6d86e632&scoped=true&lang=css"

import exportComponent from "/Users/kate/Documents/Home/live-chat/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d86e632"]])

export default __exports__